<template>
  <div>
    <app-header title="Four Seasons Code Generator" />
    <loading-spinner v-if="!history" />
    <b-container class="mt-5" v-else>
      <b-row>
        <b-col md="6">
          <b-form name="filmForm">
            <b-form-group label="Number of Codes">
              <b-form-input
                v-model="order.count"
                type="number"
                placeholder="e.g. 10"
                required
              />
            </b-form-group>
            <b-form-group label="Film Type Description">
              <b-form-select
                v-if="fsfilmtypes"
                v-model="order.fsfilmtype_id"
                :options="fsfilmtypes"
                value-field="id"
                text-field="name"
                required
              />
            </b-form-group>
          </b-form>
          <div>
            <b-button variant="primary" :disabled="!order.count || !order.fsfilmtype_id" @click="generate()">
              Generate
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <h3>Recent Activity</h3>
          <b-table-simple striped>
            <b-thead>
              <b-tr>
                <b-th>Date</b-th>
                <b-th>User</b-th>
                <b-th>Quantity</b-th>
                <b-th>Film Type</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in history" :key="item.id">
                <b-td>{{ item.created | moment("YYYY-MM-DD") }}</b-td>
                <b-td>{{ item.email }}</b-td>
                <b-td>{{ item.count }}</b-td>
                <b-td>{{ item.fsfilmtype_name }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $csv from '@/services/csv';
import AppHeader from '@/components/AppHeader';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    LoadingSpinner
  },

  data() {
    return {
      order: {},
      fsfilmtypes: null,
      history: null,
    };
  },

  created() {
    
    this.refreshHistory();
    this.fetchFilmtypes();
  },

  methods: {
    fetchFilmtypes() {
      $api.get('/v1/internal/fsfilmtypes').then((fsfilmtypes) => {
        this.fsfilmtypes = fsfilmtypes;
      });
    },

    refreshHistory() {
    $api.get('/v1/internal/fspackcredithistory').then((history) => {
        this.history = history;
      });
    },

    generate() {
      $api.post('/v1/internal/fspackcredits', this.order).then((codes) => {
        $csv.export(codes, ['code', 'fsfilmtype_name'], `${this.order.count} fspacks.csv`);
        this.refreshHistory();
      });
    },
  },
};
</script>
